<template>
  <div id="app">
    <homePage />
  </div>
</template>

<script>
import homePage from './views/index.vue'
export default {
  name: 'App',
  components: {
    homePage
  }
}
</script>

<style>
#app {
  padding: 0;
  margin: 0
}
</style>
